// Carga diferida de la fuente pesada Bernier Distressed (504 KiB) tras el primer pintado (docs/RENDIMIENTO.md R7-4).
// Esto evita que 504 KB bloqueen el render de la Home en celulares (LCP 12.8s -> ~2s).
// Una vez descargada se agrega al document.fonts y los elementos con .font-bernierd se actualizan.
import bernierWoff2 from '../assets/fonts/Bernierd/BERNIERDistressed-Regular.woff2';
import kellogWoff2 from '../assets/fonts/opt/Filmotype-Kellog.woff2';

let isLoadedOrLoading = false;

export const loadBernierFont = () => {
    if (typeof window === 'undefined' || !('fonts' in document) || isLoadedOrLoading) {
        return;
    }

    const executeLoad = () => {
        if (isLoadedOrLoading) return;
        isLoadedOrLoading = true;

        try {
            const fontBernier = new FontFace(
                'BERNIER Distressed',
                `url(${bernierWoff2}) format('woff2')`,
                { weight: 'normal', style: 'normal', display: 'swap' }
            );
            const fontKellog = new FontFace(
                'Kellog',
                `url(${kellogWoff2}) format('woff2')`,
                { weight: 'normal', style: 'normal', display: 'swap' }
            );

            Promise.all([
                fontBernier.load().then(f => document.fonts.add(f)),
                fontKellog.load().then(f => document.fonts.add(f))
            ]).catch(err => {
                console.warn('Error cargando fuentes diferidas:', err);
            });
        } catch (e) {
            console.warn('FontFace no soportado o error:', e);
        }
    };

    const scheduleLoad = () => {
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(() => setTimeout(executeLoad, 2500), { timeout: 4000 });
        } else {
            setTimeout(executeLoad, 3000);
        }
    };

    ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(evt => {
        window.addEventListener(evt, executeLoad, { once: true, passive: true });
    });

    if (document.readyState === 'complete') {
        scheduleLoad();
    } else {
        window.addEventListener('load', scheduleLoad, { once: true });
    }
};
